import { render, staticRenderFns } from "./lizeng.vue?vue&type=template&id=ea4c0196&scoped=true"
import script from "./lizeng.vue?vue&type=script&lang=js"
export * from "./lizeng.vue?vue&type=script&lang=js"
import style0 from "./lizeng.vue?vue&type=style&index=0&id=ea4c0196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4c0196",
  null
  
)

export default component.exports